/**
 * Registra o Service Worker em /service-worker.js. Idempotente — se já
 * existir um, navegador atualiza no próximo refresh.
 *
 * Em dev (vite dev server) o SW pode interferir com HMR; so registramos
 * em producao.
 */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  if (import.meta.env.DEV) return;
  if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
    return; // SW exige HTTPS (localhost é excecao para dev)
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).catch((err) => {
      // Falha silenciosa — não queremos quebrar o app
      console.warn('[sw] registracao falhou:', err);
    });
  });
}
